module.exports = __webpack_public_path__ + "img/gift_active.f4670b2b.svg";